/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_ManagerInputs */



/**
* | output |
* | --- |
* | "Manager" |
*
* @param {Team_Manager_Role_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_manager = /** @type {((inputs?: Team_Manager_Role_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manager")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manager")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gerente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("经理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente")
	return /** @type {LocalizedString} */ ("Manager")
});